import { Text, type TextProps } from '@mantine/core'

import { type CoreInquiry } from '@flecto/types'

import { useStoreOrderId } from '../../hooks/useStoreOrderId'

export type TextOrderIdProps = TextProps & {
  order?: CoreInquiry
}

export function TextOrderId({ order, ...props }: TextOrderIdProps) {
  const id = useStoreOrderId(order)

  return <Text {...props}>{id}</Text>
}
